export const getNumberFields = (template, { excludeField = null, excludeUuids = [] } = {}) => {
  return (template?.fields || []).reduce((acc, field) => {
    if (field === excludeField) return acc
    if (!['number', 'payment'].includes(field.type)) return acc
    if (excludeUuids.includes(field.uuid)) return acc

    acc.push(field)

    return acc
  }, [])
}

export const humanizeFormula = (formula, fields, buildDefaultName) => {
  if (!formula) return ''

  return formula.replace(/{{(.*?)}}/g, (match, uuid) => {
    const foundField = fields.find((f) => f.uuid === uuid)

    if (foundField) {
      return `{{${foundField.name || buildDefaultName(foundField)}}}`
    }

    return '{{FIELD NOT FOUND}}'
  })
}

export const normalizeFormula = (formula, fields, buildDefaultName) => {
  if (!formula) return ''

  return formula.replace(/{{(.*?)}}/g, (match, name) => {
    const trimmed = name.trim()
    const foundByUuid = fields.find((f) => f.uuid === trimmed)

    if (foundByUuid) {
      return `{{${foundByUuid.uuid}}}`
    }

    const foundByName = fields.find((f) => (f.name || buildDefaultName(f)).trim() === trimmed)

    if (foundByName) {
      return `{{${foundByName.uuid}}}`
    }

    return '{{FIELD NOT FOUND}}'
  })
}

export const formulaHasMissingFields = (formula) => {
  return formula.includes('FIELD NOT FOUND')
}

export const substituteFormulaValues = (formula, values, fieldsUuidIndex = {}, depth = 0) => {
  if (!formula || depth > 10) return formula

  return formula.replace(/{{(.*?)}}/g, (match, uuid) => {
    const trimmed = uuid.trim()
    const nestedField = fieldsUuidIndex[trimmed]

    if (nestedField?.preferences?.formula) {
      return `(${substituteFormulaValues(nestedField.preferences.formula, values, fieldsUuidIndex, depth + 1)})`
    }

    const raw = values[trimmed]
    const numeric = parseFloat(raw)

    return Number.isNaN(numeric) ? '0' : String(numeric)
  })
}
